
module.controller('StudentExportController', StudentExportController)

// @ngInject
function StudentExportController(program, exportTypes, StudentExportService,
                                 Debouncer, $interval) {
    var vm = this;

    var debouncedRefresh = new Debouncer(refreshSummaries);

    vm.program = program;
    vm.exportTypes = exportTypes;
    vm.tags = {};
    vm.downloading = false;

    vm.refresh = tagsChanged;
    vm.download = download;

    function download(exportType) {
        if (vm.downloading || !exportType.data.allowed) { return; }
        vm.downloading = exportType.name;
        return StudentExportService
            .downloadFile(program.id, exportType.name, vm.tags)
            .then(function() { vm.downloading = false; })
    }

    function tagsChanged(params) {
        vm.tags = params;
        // Don't start another refresh until any file finishes downloading
        var cancel = $interval(function() {
            if (!vm.downloading) {
                debouncedRefresh.call()
                $interval.cancel(cancel);
            }
        }, 200);
    }

    function refreshSummaries() {
        vm.exportTypes.forEach(function(exportType) {
            refreshSummary(exportType);
        });
    }

    function refreshSummary(exportType) {
        StudentExportService
            .getSummary(program.id, exportType.name, vm.tags)
            .then(function(summary) {exportType.data = summary; });
    }
}
